/* eslint-disable react-hooks/exhaustive-deps */
import { useFormik } from "formik";
import {
  Box,
  FormControlLabel,
  Grid,
  IconButton,
  Radio,
  RadioGroup,
  Tooltip,
  Typography,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import {
  getErrorMessage,
  getLastStep,
  getTotalYears,
  removeBlobImages,
} from "../../../utilis/common-funtions";
import {
  deleteBooking,
  setActiveStep,
  setApplicantActiveStep,
  setEditPreviewApplicant,
  setHasContinuedAsMinor,
  setHasContinuedAsMinorModal,
  setResetData,
  updateSignatory,
  verifyDigilockerStatus,
} from "../new-booking-form.slice";
import TextFieldInput from "../../../components/TextFieldInput";
import UploadInput from "../../../components/UploadInput";
import UploadPopup from "../../../shared-components/upload-popup/UploadPopup";
import CommonButton from "../../../shared-components/common-button/CommonButton";
import { useTranslation } from "react-i18next";
import InfoIcon from "@mui/icons-material/Info";
import SelectInput from "../../../components/SelectInput";
import { useState, useEffect, forwardRef, useImperativeHandle } from "react";
import { route } from "../../../services/apiRoutes";
import {
  DATE_START_YEAR,
  ERROR_MESSAGE,
  MinorAge,
  PRIMARYDOCUMENT_OPTIONS,
} from "../../../config/constant";
import { useHistory, useLocation, useParams } from "react-router-dom";
import SnackbarAlert from "../../../shared-components/snackbar-alert/SnackbarAlert";
import UploadPopupTwoImages from "../../../shared-components/upload-popup/UploadPopupTwoImages";
import { getApplicantDetails } from "../new-booking-form.slice";
import { ADDRESS_PROOF_OPTIONS } from "../../../config/constant";
import BoxCheckInput from "../../../components/BoxCheckInput";
import CustomDatePicker from "../../../components/CustomDatePicker";
import { fetchCountries } from "../../../shared-components/phone-input/phone-input-slice";
import MinorBookingModal from "./MinorBookingModal";
import ConfirmationModal from "../../../shared-components/confirmation-modal/ConfirmationModal";

const PersonalDetailsIndividual = forwardRef(({ applicantNo }, ref) => {
  const { t } = useTranslation();
  const { oppId } = useParams();
  const history = useHistory();
  const dispatch = useDispatch();

  const { countryList } = useSelector((state) => state?.countries);
  const countryOptions = countryList?.map((c) => ({
    value: c?.countryName,
    name: c?.countryName,
  }));

  const {
    activeStep,
    masterData,
    applicantData,
    hasContinuedAsMinor,
    hasContinuedAsMinorModal,
  } = useSelector((state) => state?.newBookingForm);

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const hasStatusFromDigilocker = searchParams.has("status");

  const [showUploadPopup, setShowUploadPopup] = useState({
    showUploadProfileImage: false,
    showUploadPanImage: false,
    showUploadAadharImage: false,
    showUploadAddressProofImage: false,
    showUploadPassportImage: false,
    showUploadOCICardImage: false,
    showUploadDeclaration: false,
  });
  const [snackbarConfig, setSnackBarconfig] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const applicantKey = `applicant${applicantNo}`;
  const currentApplicant = applicantData?.[applicantKey];
  const personalDetails = currentApplicant?.personalDetails;
  const [openMinorModal, setOpenMinorModal] = useState(false);
  const [openCancelMinorModal, setOpenCancelMinorModal] = useState(false);
  const [dobWarningModal, setDobWarningModal] = useState(false);
  const showForm = !openMinorModal;
  const isAadhaarOcrDone = personalDetails?.isAadhaarOcrDone ? true : false;
  const isPanOcrDone = personalDetails?.isPanOcrDone ? true : false;
  const handleOpenMinorModal = (value) => setOpenMinorModal(value);

  const handleContinueAsMinor = () => {
    setOpenCancelMinorModal(false);
    setOpenMinorModal(false);
    formik.setFieldValue("hasContinuedAsMinor", true);
  };

  const handleMinorModalClose = () => {
    // Show confirmation modal when user tries to cancel
    setOpenMinorModal(false);
    setOpenCancelMinorModal(!openCancelMinorModal);
  };

  const handleCancleMinorModalClose = () => {
    setOpenCancelMinorModal(false);
    setOpenMinorModal(true);
  };

  const handleConfirmCancelMinor = () => {
    // Close both modals and reset DOB
    setOpenCancelMinorModal(false);
    setOpenMinorModal(false);
    if (applicantNo === 1) {
      handleClearApplicantData();
    }
    dispatch(setHasContinuedAsMinor(false));
    dispatch(setHasContinuedAsMinorModal(false));
    formik.setFieldValue("dob", "");
  };

  const handleClearApplicantData = () => {
    setOpenCancelMinorModal(!openCancelMinorModal);
    let payload = {
      opportunityId: oppId,
    };
    dispatch(deleteBooking(payload))
      .unwrap()
      .then((res) => {
        if (res?.statusCode === 200 || res?.statusCode === 201) {
          dispatch(setResetData());
          window.location.href = `/booking-form/${oppId}`;
        }
      })
      .catch((error) => {
        setSnackBarconfig({
          open: true,
          message: ERROR_MESSAGE,
          severity: "error",
        });
      });
  };

  const formik = useFormik({
    initialValues: {
      aadhaarNumber: "",
      aadhaarImage: [],
      isAadhaarSkipped: false,
      isAadhaarVerified: false,
      nameAsPerAadhaar: "",
      panNumber: "",
      panImage: [],
      isPanSkipped: false,
      isPanVerified: false,
      nameAsPerPan: "",
      passportNumber: "",
      passportImage: [],
      ociNumber: "",
      ociCardImage: [],
      addressProofType: "",
      addressProofImage: [],
      primaryDocument: "Aadhaar",
      residentStatus: "",
      salutation: "",
      firstName: "",
      lastName: "",
      dob: "",
      gender: "",
      relation: "",
      relativeName: "",
      hasContinuedAsMinor: false,
      fatherName: "",
      motherName: "",
      legalGuardian: "",
      legalGuardianDoc: [],
      image: [],
      nriCountry: "",
      isPhysicalAadhaar: false,
      isPhysicalPan: false,
      isPhysicalAddressProof: false,
      isPhysicalPassport: false,
      isPhysicalOCI: false,
      isPhysicalLegalGuardianDoc: false,
      isPhysicalImage: false,
    },
    validationSchema: Yup.object({
      aadhaarNumber: Yup.string().when(
        ["residentStatus", "isAadhaarSkipped", "isAadhaarVerified"],
        {
          is: (residentStatus, isAadhaarSkipped, isAadhaarVerified) =>
            residentStatus !== t("residentStatusOptions.PIO_OCI") &&
            !isAadhaarSkipped &&
            !isAadhaarVerified,
          then: (schema) =>
            schema
              .matches(
                /^[2-9]{1}[0-9]{11}$/,
                t(
                  "authorizedSignatoryDetails.fields.aadhaarNumber.validation.pattern"
                )
              )
              .required(
                t(
                  "authorizedSignatoryDetails.fields.aadhaarNumber.validation.required"
                )
              ),
          otherwise: (schema) => schema.notRequired(),
        }
      ),

      aadhaarImage: Yup.array().when(
        ["residentStatus", "isPhysicalAadhaar", "isAadhaarSkipped"],
        {
          is: (residentStatus, isPhysicalAadhaar, isAadhaarSkipped) =>
            residentStatus !== t("residentStatusOptions.PIO_OCI") &&
            !isAadhaarSkipped &&
            !isPhysicalAadhaar,
          then: (schema) =>
            schema
              .min(
                1,
                t(
                  "authorizedSignatoryDetails.fields.aadhaarImage.validation.min"
                )
              )
              .required(
                t(
                  "authorizedSignatoryDetails.fields.aadhaarImage.validation.required"
                )
              ),
          otherwise: (schema) => schema.notRequired(),
        }
      ),

      panNumber: Yup.string().when("isPanSkipped", {
        is: false,
        then: (schema) =>
          schema
            .matches(
              /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
              t(
                "authorizedSignatoryDetails.fields.panNumber.validation.pattern"
              )
            )
            .required(
              t(
                "authorizedSignatoryDetails.fields.panNumber.validation.required"
              )
            ),
        otherwise: (schema) => schema.notRequired(),
      }),

      panImage: Yup.array().when(["isPhysicalPan", "isPanSkipped"], {
        is: (isPhysicalPan, isPanSkipped) => !isPhysicalPan && !isPanSkipped,
        then: (schema) =>
          schema
            .min(
              1,
              t(
                "authorizedSignatoryDetails.fields.panNumberImage.validation.min"
              )
            )
            .required(
              t(
                "authorizedSignatoryDetails.fields.panNumberImage.validation.required"
              )
            ),
        otherwise: (schema) => schema.notRequired(),
      }),

      passportNumber: Yup.string().when(["residentStatus"], {
        is: (residentStatus) =>
          [
            t("residentStatusOptions.NRI"),
            t("residentStatusOptions.PIO_OCI"),
          ].includes(residentStatus),
        then: (schema) =>
          schema
            .matches(
              /^[A-Za-z0-9]{6,9}$/,
              t(
                "authorizedSignatoryDetails.fields.passportNumber.validation.pattern"
              )
            )
            .required(
              t(
                "authorizedSignatoryDetails.fields.passportNumber.validation.required"
              )
            ),
        otherwise: (schema) => schema.notRequired(),
      }),

      passportImage: Yup.array().when(
        ["isPhysicalPassport", "residentStatus"],
        {
          is: (isPhysicalPassport, residentStatus) =>
            !isPhysicalPassport &&
            [
              t("residentStatusOptions.NRI"),
              t("residentStatusOptions.PIO_OCI"),
            ].includes(residentStatus),
          then: (schema) =>
            schema
              .min(
                1,
                t(
                  "authorizedSignatoryDetails.fields.passportImage.validation.min"
                )
              )
              .required(
                t(
                  "authorizedSignatoryDetails.fields.passportImage.validation.required"
                )
              ),
          otherwise: (schema) => schema.notRequired(),
        }
      ),

      ociNumber: Yup.string().when(["residentStatus"], {
        is: (residentStatus) =>
          [t("residentStatusOptions.PIO_OCI")].includes(residentStatus),
        then: (schema) =>
          schema
            .matches(
              /^[A-Z][0-9]{7}$/,
              t(
                "authorizedSignatoryDetails.fields.ociNumber.validation.pattern"
              )
            )
            .required(
              t(
                "authorizedSignatoryDetails.fields.ociNumber.validation.required"
              )
            ),
        otherwise: (schema) => schema.notRequired(),
      }),

      ociCardImage: Yup.array().when(["isPhysicalOCI", "residentStatus"], {
        is: (isPhysicalOCI, residentStatus) =>
          !isPhysicalOCI &&
          residentStatus === t("residentStatusOptions.PIO_OCI"),
        then: (schema) =>
          schema
            .min(
              1,
              t("authorizedSignatoryDetails.fields.ociCardImage.validation.min")
            )
            .required(
              t(
                "authorizedSignatoryDetails.fields.ociCardImage.validation.required"
              )
            ),
        otherwise: (schema) => schema.notRequired(),
      }),

      addressProofImage: Yup.array().when(
        ["isPhysicalAddressProof", "addressProofType"],
        {
          is: (isPhysicalAddressProof, addressProofType) =>
            !isPhysicalAddressProof && !!addressProofType,
          then: (schema) =>
            schema
              .min(
                1,
                t(
                  "authorizedSignatoryDetails.fields.addressProofImage.validation.min"
                )
              )
              .required(
                t(
                  "authorizedSignatoryDetails.fields.addressProofImage.validation.required"
                )
              ),
          otherwise: (schema) => schema.notRequired(),
        }
      ),

      primaryDocument: Yup.string()
        .oneOf(
          ["Aadhaar", "PAN"],
          t(
            "authorizedSignatoryDetails.fields.primaryDocument.validation.required"
          )
        )
        .required(
          t(
            "authorizedSignatoryDetails.fields.primaryDocument.validation.required"
          )
        ),

      salutation: Yup.string().required(
        t("authorizedSignatoryDetails.fields.salutation.validation.required")
      ),

      firstName: Yup.string()
        .matches(
          /^[A-Za-z\s]+$/,
          t("authorizedSignatoryDetails.fields.firstName.validation.pattern")
        )
        .max(
          50,
          t("authorizedSignatoryDetails.fields.firstName.validation.max")
        )
        .required(
          t("authorizedSignatoryDetails.fields.firstName.validation.required")
        ),

      lastName: Yup.string()
        .matches(
          /^[A-Za-z\s]+$/,
          t("authorizedSignatoryDetails.fields.lastName.validation.pattern")
        )
        .max(50, t("authorizedSignatoryDetails.fields.lastName.validation.max"))
        .nullable()          
        .notRequired(),      


      gender: Yup.string().required(t("commonValidations.gender")),

      dob: Yup.string().required(t("commonValidations.dob")),

      relation: Yup.string().when("hasContinuedAsMinor", {
        is: false,
        then: (schema) => schema.required(t("commonValidations.careOf")),
        otherwise: (schema) => schema.notRequired(),
      }),

      relativeName: Yup.string().when("hasContinuedAsMinor", {
        is: false,
        then: (schema) =>
          schema
            .matches(
              /^[A-Za-z\s]+$/,
              t(
                "authorizedSignatoryDetails.fields.relativeName.validation.pattern"
              )
            )
            .min(
              2,
              t("authorizedSignatoryDetails.fields.firstName.validation.min")
            )
            .max(
              100,
              t("authorizedSignatoryDetails.fields.firstName.validation.max")
            )
            .required(t("commonValidations.careOfWithName")),
        otherwise: (schema) => schema.notRequired(),
      }),

      fatherName: Yup.string().when("hasContinuedAsMinor", {
        is: true,
        then: () =>
          Yup.string()
            .matches(
              /^[A-Za-z\s]+$/,
              t(
                "authorizedSignatoryDetails.fields.fatherName.validation.pattern"
              )
            )
            .min(
              2,
              t("authorizedSignatoryDetails.fields.firstName.validation.min")
            )
            .max(
              100,
              t("authorizedSignatoryDetails.fields.firstName.validation.max")
            )
            .required(t("minorDetails.validations.fatherName")),
        otherwise: () => Yup.string().notRequired(),
      }),

      motherName: Yup.string().when("hasContinuedAsMinor", {
        is: true,
        then: () =>
          Yup.string()
            .matches(
              /^[A-Za-z\s]+$/,
              t(
                "authorizedSignatoryDetails.fields.motherName.validation.pattern"
              )
            )
            .min(
              2,
              t("authorizedSignatoryDetails.fields.firstName.validation.min")
            )
            .max(
              100,
              t("authorizedSignatoryDetails.fields.firstName.validation.max")
            )
            .required(t("minorDetails.validations.motherName")),
        otherwise: () => Yup.string().notRequired(),
      }),

      legalGuardian: Yup.string().when("hasContinuedAsMinor", {
        is: true,
        then: () =>
          Yup.string().required(t("minorDetails.validations.legalGuardian")),
        otherwise: () => Yup.string().notRequired(),
      }),

      legalGuardianDoc: Yup.array().when(
        ["isPhysicalLegalGuardianDoc", "hasContinuedAsMinor"],
        {
          is: (isPhysicalLegalGuardianDoc, hasContinuedAsMinor) =>
            !isPhysicalLegalGuardianDoc && hasContinuedAsMinor,
          then: () =>
            Yup.array()
              .min(1, t("minorDetails.validations.legalGuardianDoc.min"))
              .required(
                t("minorDetails.validations.legalGuardianDoc.required")
              ),
          otherwise: () => Yup.array().notRequired(),
        }
      ),

      image: Yup.array().when("isPhysicalImage", {
        is: false,
        then: (schema) =>
          schema
            .min(1, t("authorizedSignatoryDetails.fields.image.validation.min"))
            .required(
              t("authorizedSignatoryDetails.fields.image.validation.required")
            ),
        otherwise: (schema) => schema.notRequired(),
      }),

      nriCountry: Yup.string().when("residentStatus", {
        is: t("residentStatusOptions.NRI"),
        then: () => Yup.string().required(t("commonValidations.nriCountry")),
        otherwise: () => Yup.string().notRequired(),
      }),
    }),
    onSubmit: async (values, { setSubmitting }) => {
      setSubmitting(false);
    },
  });

  const isNameFieldsDisabled =
    (formik.values?.isAadhaarSkipped && formik.values?.isPanSkipped) ||
    (formik.values?.residentStatus === t("residentStatusOptions.PIO_OCI") &&
      formik.values?.isPanSkipped);

  const showAadhaarFields =
    personalDetails?.residentStatus === t("residentStatusOptions.PIO_OCI")
      ? personalDetails?.aadhaarImage?.length > 0
      : !formik.values?.isAadhaarSkipped;

  const showPrimaryDocument =
    personalDetails?.residentStatus === t("residentStatusOptions.PIO_OCI")
      ? personalDetails?.aadhaarImage?.length > 0 &&
        !formik?.values?.isPanSkipped
      : !(formik?.values?.isAadhaarSkipped || formik?.values?.isPanSkipped);

  useImperativeHandle(ref, () => ({
    handleSubmit,
    errors: formik.errors,
  }));

  useEffect(() => {
    dispatch(fetchCountries());
    dispatch(getApplicantDetails(`/${oppId}`));
  }, []);

  useEffect(() => {
    if (personalDetails) {
      formik.setValues({
        aadhaarNumber: personalDetails?.aadhaarNumber || "",
        aadhaarImage: personalDetails?.aadhaarImage || [],
        isAadhaarSkipped: personalDetails?.isAadhaarSkipped ?? false,
        isAadhaarVerified: personalDetails.isAadhaarVerified ?? false,
        nameAsPerAadhaar: personalDetails?.nameAsPerAadhaar || "",
        panNumber: personalDetails?.panNumber || "",
        panImage: personalDetails?.panImage || [],
        isPanSkipped: personalDetails?.isPanSkipped ?? false,
        isPanVerified: personalDetails.isPanVerified ?? false,
        nameAsPerPan: personalDetails?.nameAsPerPan || "",
        passportNumber: personalDetails?.passportNumber ?? "",
        passportImage: personalDetails?.passportImage ?? [],
        ociNumber: personalDetails?.ociNumber ?? "",
        ociCardImage: personalDetails?.ociImage ?? [],
        addressProofType: personalDetails?.addressProofType || "",
        addressProofImage: personalDetails?.addressProofImage || [],
        primaryDocument: personalDetails?.primaryDocument
          ? personalDetails?.primaryDocument
          : personalDetails?.residentStatus ===
              t("residentStatusOptions.PIO_OCI") &&
            !(personalDetails?.aadhaarImage?.length > 0)
          ? PRIMARYDOCUMENT_OPTIONS?.Pan
          : personalDetails?.isAadhaarSkipped
          ? PRIMARYDOCUMENT_OPTIONS?.Pan
          : PRIMARYDOCUMENT_OPTIONS?.Aadhaar,

        residentStatus: personalDetails?.residentStatus ?? "",
        salutation: personalDetails?.salutation || "",
        firstName: personalDetails?.firstName || "",
        lastName: personalDetails?.lastName || "",
        dob: personalDetails?.dob || "",
        gender: personalDetails?.gender || "",
        relation: personalDetails?.relation || "",
        relativeName: personalDetails?.relativeName || "",
        hasContinuedAsMinor: personalDetails?.hasContinuedAsMinor ?? false,
        fatherName: personalDetails?.fatherName || "",
        motherName: personalDetails?.motherName || "",
        legalGuardian: personalDetails?.legalGuardian || "",
        image: personalDetails?.image || [],
        legalGuardianDoc: personalDetails?.legalGuardianDoc || [],
        nriCountry: personalDetails?.nriCountry || "",
        isPhysicalAadhaar: personalDetails?.isPhysicalAadhaar ?? false,
        isPhysicalPan: personalDetails?.isPhysicalPan ?? false,
        isPhysicalAddressProof:
          personalDetails?.isPhysicalAddressProof ?? false,
        isPhysicalPassport: personalDetails?.isPhysicalPassport ?? false,
        isPhysicalOCI: personalDetails?.isPhysicalOCI ?? false,
        isPhysicalLegalGuardianDoc:
          personalDetails?.isPhysicalLegalGuardianDoc ?? false,
        isPhysicalImage: personalDetails?.isPhysicalImage ?? false,
      });
    } else {
      formik.resetForm();
    }
  }, [applicantData, applicantNo, personalDetails]);

  useEffect(() => {
    if (hasContinuedAsMinorModal) {
      handleOpenMinorModal(true);
    } else {
      handleOpenMinorModal(false);
    }
  }, [hasContinuedAsMinorModal]);

  useEffect(() => {
    if (hasContinuedAsMinor) {
      formik.setFieldValue("hasContinuedAsMinor", true);
    } else {
      formik.setFieldValue("hasContinuedAsMinor", false);
    }
  }, [hasContinuedAsMinor, applicantData]);

  useEffect(() => {
    checkDigilockerStatus();
  }, [hasStatusFromDigilocker, oppId]);

  const checkDigilockerStatus = async () => {
    try {
      if (hasStatusFromDigilocker) {
        const res = await dispatch(
          verifyDigilockerStatus(`/${oppId}`)
        ).unwrap();

        const url = new URL(window.location);
        url.search = ""; // clears everything after ?
        window.history.replaceState({}, "", url);

        if (res) {
          setSnackBarconfig({
            open: true,
            message: res?.message || ERROR_MESSAGE,
            severity: "success",
          });
        }
      }
    } catch (err) {
      setSnackBarconfig({
        open: true,
        message: getErrorMessage(err),
        severity: "error",
      });
    }
  };

  useEffect(() => {
    const splitName = (fullName = "") => {
      if (!fullName) return { firstName: "", lastName: "" };
      const parts = fullName.trim().split(" ");
      return {
        firstName: parts[0] || "",
        lastName: parts.slice(1).join(" ") || "",
      };
    };

    if (
      formik.values.primaryDocument === "Aadhaar" &&
      formik.values.nameAsPerAadhaar
    ) {
      const { firstName, lastName } = splitName(formik.values.nameAsPerAadhaar);
      formik.setFieldValue("firstName", firstName);
      formik.setFieldValue("lastName", lastName);
    }

    if (formik.values.primaryDocument === "PAN" && formik.values.nameAsPerPan) {
      const { firstName, lastName } = splitName(formik.values.nameAsPerPan);
      formik.setFieldValue("firstName", firstName);
      formik.setFieldValue("lastName", lastName);
    }
  }, [
    formik.values.primaryDocument,
    formik.values.nameAsPerAadhaar,
    formik.values.nameAsPerPan,
    applicantData,
  ]);

  const handleUpdateImageData = (fieldName, imageData) => {
    formik.setFieldValue(fieldName, imageData);
  };

  const handleImageValue = (keyName, imgName) => {
    removeBlobImages();
    formik.setFieldValue(keyName, imgName);
  };

  const handlePhysicalImage = (fieldName, value) => {
    const fieldMap = {
      image: "isPhysicalImage",
      panImage: "isPhysicalPan",
      aadhaarImage: "isPhysicalAadhaar",
      addressProofImage: "isPhysicalAddressProof",
      passportImage: "isPhysicalPassport",
      ociCardImage: "isPhysicalOCI",
      legalGuardianDoc: "isPhysicalLegalGuardianDoc",
    };

    formik.setFieldValue(fieldMap[fieldName], value);
  };

  const handleOnChange = (e, index, key, list) => {
    let selectedValue = list[index]?.value;
    formik.setFieldValue(key, selectedValue);
  };

  const handleSalutationChange = (e, index, key) => {
    if (key !== "salutation") return;

    const value = e.target.value;
    formik.setFieldValue(key, value);

    const selectedOption = masterData?.Salutation?.find(
      (option) => option.value === value
    );
    if (!selectedOption) return;

    const salutation = selectedOption.name?.toLowerCase();

    const salutationGenderMap = {
      mr: "male",
      "mr.": "male",
      ms: "female",
      "ms.": "female",
      mrs: "female",
      "mrs.": "female",
    };

    const genderKey = salutationGenderMap[salutation];
    if (!genderKey) {
      formik.setFieldValue("gender", "");
      return;
    }

    const genderOption = masterData?.GenderIdentity?.find(
      (option) => option.name?.toLowerCase() === genderKey
    );
    formik.setFieldValue("gender", genderOption?.value || "");
  };

  const togglePopup = (type) => {
    removeBlobImages();

    const keyMap = {
      profile: "showUploadProfileImage",
      pan: "showUploadPanImage",
      aadhaar: "showUploadAadharImage",
      addressProof: "showUploadAddressProofImage",
      passport: "showUploadPassportImage",
      ociCard: "showUploadOCICardImage",
      legalGuardianDoc: "showUploadDeclaration",
    };

    const key = keyMap[type];

    if (key) {
      setShowUploadPopup((prev) => ({
        ...prev,
        [key]: !prev[key],
      }));
    }
  };

  const buildPayload = (saveForLater = false) => {
    const hasContinuedAsMinor = formik.values?.hasContinuedAsMinor;

    let primaryDocumentValue = formik.values?.primaryDocument;

    if (formik.values?.isAadhaarSkipped && !formik.values?.isPanSkipped) {
      primaryDocumentValue = "PAN";
    } else if (
      formik.values?.isPanSkipped &&
      !formik.values?.isAadhaarSkipped
    ) {
      primaryDocumentValue = "Aadhaar";
    } else if (formik.values?.isPanSkipped && formik.values?.isAadhaarSkipped) {
      primaryDocumentValue = null;
    }

    return {
      opportunityId: oppId,
      applicantNumber: applicantNo,
      lastStep: getLastStep(applicantData?.lastStep, activeStep),
      saveForLater: saveForLater,
      hasContinuedAsMinor,
      personalDetails: {
        aadhaarNumber: formik.values?.aadhaarNumber,
        aadhaarImage: formik.values?.aadhaarImage,
        nameAsPerAadhaar: formik.values?.nameAsPerAadhaar,
        panNumber: formik.values?.panNumber,
        panImage: formik.values?.panImage,
        nameAsPerPan: formik.values?.nameAsPerPan,
        passportNumber: formik.values?.passportNumber,
        passportImage: formik.values?.passportImage,
        ociNumber: formik.values?.ociNumber,
        ociCardImage: formik.values?.ociCardImage,
        addressProofType: formik.values?.addressProofType,
        addressProofImage: formik.values?.addressProofImage,
        primaryDocument: primaryDocumentValue,
        residentStatus: formik.values?.residentStatus,
        salutation: formik.values?.salutation,
        firstName: formik.values?.firstName,
        lastName: formik.values?.lastName,
        relation: hasContinuedAsMinor ? null : formik.values?.relation,
        relativeName: hasContinuedAsMinor ? null : formik.values?.relativeName,
        dob: formik.values?.dob,
        gender: formik.values?.gender,
        fatherName: formik.values?.fatherName,
        motherName: formik.values?.motherName,
        legalGuardian: formik.values?.legalGuardian,
        legalGuardianDoc: formik.values?.legalGuardianDoc,
        image: formik.values?.image,
        nriCountry: formik.values?.nriCountry,
        isPhysicalAadhaar: formik.values?.isPhysicalAadhaar,
        isPhysicalPan: formik.values?.isPhysicalPan,
        isPhysicalAddressProof: formik.values?.isPhysicalAddressProof,
        isPhysicalPassport: formik.values?.isPhysicalPassport,
        isPhysicalOCI: formik.values?.isPhysicalOCI,
        isPhysicalLegalGuardianDoc: formik.values?.isPhysicalLegalGuardianDoc,
        isPhysicalImage: formik.values?.isPhysicalImage,
      },
    };
  };

  const handleSubmit = async (isSaveandPreview = false) => {
    const errors = await formik.validateForm();

    if (Object.keys(errors).length === 0) {
      if (formik?.values?.dob && !hasContinuedAsMinor) {
        const age = getTotalYears(formik?.values?.dob);
        if (
          parseInt(age) < MinorAge &&
          !applicantData?.[applicantKey]?.hasContinuedAsMinor
        ) {
          dispatch(setHasContinuedAsMinorModal(true));
          dispatch(setHasContinuedAsMinor(true));
          return;
        }
      }
      try {
        const response = await dispatch(
          updateSignatory({
            path: route.UPDATE_APPLICANT_DATA,
            payload: buildPayload(false),
            opportunityId: oppId,
          })
        ).unwrap();

        if (response) {
          dispatch(setApplicantActiveStep(1));
          if (isSaveandPreview) {
            dispatch(setEditPreviewApplicant(false));
            history.push(`/customer-preview/${oppId}`);
          }
        }
      } catch (error) {
        setSnackBarconfig({
          open: true,
          message: getErrorMessage(error),
          severity: "error",
        });
      }
    } else {
      formik.setTouched(
        Object.keys(errors).reduce((acc, key) => ({ ...acc, [key]: true }), {})
      );
    }
  };

  const handleNext = () => {
    handleSubmit();
  };

  const handlePrevious = () => {
    dispatch(setActiveStep(activeStep - 1));
  };

  const handleSaveAndPreview = () => {
    handleSubmit(true);
  };

  const handleSnackbarClose = () => {
    setSnackBarconfig({
      open: false,
      message: "",
      severity: "",
    });
  };

  const handleCloseDOBwarningModal = () => {
    formik.setFieldValue("dob", null);
    setDobWarningModal(false);
  };

  return (
    <>
      <MinorBookingModal
        open={openMinorModal}
        onClose={handleMinorModalClose}
        onContinueAsMinor={handleContinueAsMinor}
        // isFirstMinor= {applicantData?.applicant2?.hasContinuedAsMinor  ? true : false}
        isFirstMinor={
          applicantData?.applicant2?.hasContinuedAsMinor &&
          applicantData?.applicant1?.hasContinuedAsMinor
            ? true
            : false
        }
      />
      <ConfirmationModal
        open={openCancelMinorModal}
        onClose={() => handleCancleMinorModalClose()}
        onConfirm={handleConfirmCancelMinor}
        title="Cancel Minor Booking?"
        message="Are you sure you want to cancel? The date of birth will be cleared and you'll need to re-enter it."
        confirmText="Yes, Cancel"
        cancelText="No"
        disableBackdropClick={true}
        hideCloseIcon={true}
      />
      <ConfirmationModal
        open={dobWarningModal}
        onClose={handleCloseDOBwarningModal}
        onConfirm={handleCloseDOBwarningModal}
        title="Age Restriction Notice"
        message="Primary applicant must be an adult. Please update the date of birth."
        confirmText="OK"
        disableBackdropClick={true}
        hideCloseIcon={true}
      />
      {showForm && (
        <form onSubmit={formik.handleSubmit} autoComplete="off">
          <Grid container spacing={2}>
            {/* Aadhaar Upload */}
            {showAadhaarFields && (
              <Grid item xs={12} sm={6}>
                <UploadInput
                  field={{
                    inputValueFieldName: "aadhaarNumber",
                    label: t(
                      "authorizedSignatoryDetails.fields.aadhaarNumber.label"
                    ),
                    name: "aadhaarImage",
                    placeholder: formik?.values?.aadhaarNumber,
                    placeholderUpload: formik?.values?.aadhaarNumber,
                    required:
                      formik.values?.residentStatus !==
                      t("residentStatusOptions.PIO_OCI"),
                    editabletextFieldPlaceholder: t(
                      "authorizedSignatoryDetails.fields.aadhaarNumber.placeholder"
                    ),
                    handleOnClick: () => togglePopup("aadhaar"),
                    physicalCopyValue: formik?.values?.isPhysicalAadhaar,
                    handleOnChange: (e) => {
                      const value = e.target.value?.replace(/\D/g, ""); // remove non-digits
                      formik.setFieldValue(
                        "aadhaarNumber",
                        value?.slice(0, 12)
                      ); // limit to 12
                    },
                  }}
                  textfieldReadonly={
                    personalDetails?.isAadhaarVerified ? true : false
                  }
                  formik={formik}
                />
                {showUploadPopup?.showUploadAadharImage && (
                  <UploadPopupTwoImages
                    heading={t(
                      "authorizedSignatoryDetails.fields.aadhaarImage.popup.heading"
                    )}
                    totalImages={2}
                    closePopup={() => togglePopup("aadhaar")}
                    handleImageValue={handleImageValue}
                    uploadedImageFront={formik?.values?.aadhaarImage?.[0] || []}
                    uploadedImageBack={formik?.values?.aadhaarImage?.[1] || []}
                    fieldName={"aadhaarImage"}
                    handleUpdateImageData={handleUpdateImageData}
                    handlePhysicalImage={handlePhysicalImage}
                    selectedOptionValue={formik?.values?.isPhysicalAadhaar}
                    dynamicSize={2}
                    showPreview={isAadhaarOcrDone ? "show" : ""}
                    showDeleteIcon={isAadhaarOcrDone ? false : true}
                  />
                )}
              </Grid>
            )}

            {/* PAN Upload */}
            {!formik?.values?.isPanSkipped && (
              <Grid item xs={12} sm={6}>
                <UploadInput
                  field={{
                    inputValueFieldName: "panNumber",
                    label: t(
                      "authorizedSignatoryDetails.fields.panNumber.label"
                    ),
                    name: "panImage",
                    placeholder: formik?.values?.panNumber,
                    placeholderUpload: formik?.values?.panNumber,
                    required: true,
                    handleOnChange: (e) => {
                      const value = e.target?.value?.replace(
                        /[^A-Za-z0-9]/g,
                        ""
                      ); // allow only letters + numbers
                      formik.setFieldValue(
                        "panNumber",
                        value?.toUpperCase()?.slice(0, 10)
                      ); // uppercase + limit
                    },
                    editabletextFieldPlaceholder: t(
                      "authorizedSignatoryDetails.fields.panNumber.placeholder"
                    ),

                    handleOnClick: () => togglePopup("pan"),
                    physicalCopyValue: formik?.values?.isPhysicalPan,
                  }}
                  textfieldReadonly={
                    personalDetails?.isPanVerified ? true : false
                  }
                  formik={formik}
                />
                {showUploadPopup?.showUploadPanImage && (
                  <UploadPopup
                    heading={t(
                      "authorizedSignatoryDetails.fields.panNumberImage.popup.heading"
                    )}
                    totalImages={1}
                    closePopup={() => togglePopup("pan")}
                    handleImageValue={handleImageValue}
                    uploadedImage={formik?.values?.panImage}
                    fieldName={"panImage"}
                    handleUpdateImageData={handleUpdateImageData}
                    handlePhysicalImage={handlePhysicalImage}
                    selectedOptionValue={formik?.values?.isPhysicalPan}
                    dynamicSize={2}
                    showDeleteIcon={
                      formik.values?.isPanVerified
                        ? false
                        : isPanOcrDone
                        ? false
                        : true
                    }
                    showPreview={isPanOcrDone ? "show" : ""}
                  />
                )}
              </Grid>
            )}

            {/* Name as per Aadhaar */}
            {showAadhaarFields && (
              <Grid item xs={12} sm={6}>
                <TextFieldInput
                  field={{
                    name: "nameAsPerAadhaar",
                    label: t(
                      "authorizedSignatoryDetails.fields.nameAsPerAadhaar.label"
                    ),
                    required: false,
                    readonly: personalDetails?.isAadhaarVerified ? true : false,
                    showCheckIcon: personalDetails?.isAadhaarVerified
                      ? true
                      : false,
                    placeholder: t(
                      "authorizedSignatoryDetails.fields.nameAsPerAadhaar.placeholder"
                    ),
                    handleOnChange: (e) => {
                      const newValue = e.target.value?.replace(
                        /[^a-zA-Z\s]/g,
                        ""
                      );
                      formik.setFieldValue("nameAsPerAadhaar", newValue);
                    },
                  }}
                  formik={formik}
                />
              </Grid>
            )}

            {/* Name as per PAN */}
            {!formik?.values?.isPanSkipped && (
              <Grid item xs={12} sm={6}>
                <TextFieldInput
                  field={{
                    name: "nameAsPerPan",
                    label: t(
                      "authorizedSignatoryDetails.fields.nameAsPerPan.label"
                    ),
                    required: false,
                    readonly: personalDetails?.isPanVerified ? true : false,
                    showCheckIcon: personalDetails?.isPanVerified
                      ? true
                      : false,
                    placeholder: t(
                      "authorizedSignatoryDetails.fields.nameAsPerPan.placeholder"
                    ),
                    handleOnChange: (e) => {
                      const newValue = e.target.value?.replace(
                        /[^a-zA-Z\s]/g,
                        ""
                      );
                      formik.setFieldValue("nameAsPerPan", newValue);
                    },
                  }}
                  formik={formik}
                />
              </Grid>
            )}

            {/* Passport Number and Passport Upload */}
            {[
              t("residentStatusOptions.NRI"),
              t("residentStatusOptions.PIO_OCI"),
            ].includes(formik.values?.residentStatus) && (
              <Grid item xs={12} sm={6}>
                <UploadInput
                  field={{
                    inputValueFieldName: "passportNumber",
                    label: t(
                      "authorizedSignatoryDetails.fields.passportNumber.label"
                    ),
                    name: "passportImage",
                    placeholder: formik?.values?.passportNumber,
                    placeholderUpload: formik?.values?.passportNumber,
                    required: true,
                    handleOnChange: (e) => {
                      const value = e.target?.value?.replace(
                        /[^A-Za-z0-9]/g,
                        ""
                      );
                      formik.setFieldValue(
                        "passportNumber",
                        value?.toUpperCase().slice(0, 9)
                      );
                    },
                    editabletextFieldPlaceholder: t(
                      "authorizedSignatoryDetails.fields.passportNumber.placeholder"
                    ),

                    handleOnClick: () => togglePopup("passport"),
                    physicalCopyValue: formik?.values?.isPhysicalPassport,
                  }}
                  textfieldReadonly={false}
                  formik={formik}
                />
                {showUploadPopup?.showUploadPassportImage && (
                  <UploadPopup
                    heading={t(
                      "authorizedSignatoryDetails.fields.passportImage.popup.heading"
                    )}
                    totalImages={1}
                    closePopup={() => togglePopup("passport")}
                    handleImageValue={handleImageValue}
                    uploadedImage={formik?.values?.passportImage}
                    fieldName={"passportImage"}
                    handleUpdateImageData={handleUpdateImageData}
                    handlePhysicalImage={handlePhysicalImage}
                    selectedOptionValue={formik?.values?.isPhysicalPassport}
                    dynamicSize={2}
                  />
                )}
              </Grid>
            )}

            {formik.values?.residentStatus ===
              t("residentStatusOptions.PIO_OCI") && (
              <Grid item xs={12} sm={6}>
                <UploadInput
                  field={{
                    inputValueFieldName: "ociNumber",
                    name: "ociCardImage",
                    label: t(
                      "authorizedSignatoryDetails.fields.ociCardImage.label"
                    ),
                    placeholder: formik?.values?.ociNumber,
                    placeholderUpload: formik?.values?.ociNumber,
                    required: true,
                    handleOnChange: (e) => {
                      const value = e.target?.value?.replace(
                        /[^A-Za-z0-9]/g,
                        ""
                      );
                      formik.setFieldValue(
                        "ociNumber",
                        value.toUpperCase().slice(0, 8)
                      );
                    },
                    editabletextFieldPlaceholder: t(
                      "authorizedSignatoryDetails.fields.ociNumber.placeholder"
                    ),
                    handleOnClick: () => togglePopup("ociCard"),
                    physicalCopyValue: formik?.values?.isPhysicalOCI,
                  }}
                  textfieldReadonly={false}
                  formik={formik}
                />
                {showUploadPopup?.showUploadOCICardImage && (
                  <UploadPopup
                    heading={t(
                      "authorizedSignatoryDetails.fields.ociCardImage.popup.heading"
                    )}
                    totalImages={1}
                    closePopup={() => togglePopup("ociCard")}
                    handleImageValue={handleImageValue}
                    uploadedImage={formik?.values?.ociCardImage}
                    fieldName={"ociCardImage"}
                    handleUpdateImageData={handleUpdateImageData}
                    handlePhysicalImage={handlePhysicalImage}
                    selectedOptionValue={formik?.values?.isPhysicalOCI}
                    dynamicSize={2}
                  />
                )}
              </Grid>
            )}

            {/* Address Proof */}
            {formik?.values?.addressProofType && (
              <Grid item xs={12} sm={6}>
                <SelectInput
                  field={{
                    label: t(
                      "authorizedSignatoryDetails.fields.addressProofImage.typeLabel"
                    ),
                    name: "addressProofType",
                    readonly: false,
                    options: ADDRESS_PROOF_OPTIONS,
                    placeholder: "Select Address Proof",
                  }}
                  formik={formik}
                />
              </Grid>
            )}

            {formik?.values?.addressProofType && (
              <Grid item xs={12} sm={6}>
                <UploadInput
                  field={{
                    name: "addressProofImage",
                    label: t(
                      "authorizedSignatoryDetails.fields.addressProofImage.imageLabel"
                    ),
                    placeholder: formik?.values?.isPhysicalAddressProof
                      ? t(
                          "authorizedSignatoryDetails.fields.addressProofImage.upload.physicalCopy"
                        )
                      : t(
                          "authorizedSignatoryDetails.fields.addressProofImage.upload.placeholder"
                        ),
                    placeholderUpload: t("commonPlaceholders.uploaded"),
                    required: true,
                    handleOnClick: () => togglePopup("addressProof"),
                    physicalCopyValue: formik?.values?.isPhysicalAddressProof,
                  }}
                  formik={formik}
                />
                {showUploadPopup?.showUploadAddressProofImage && (
                  <UploadPopup
                    heading={t(
                      "authorizedSignatoryDetails.fields.addressProofImage.popup.heading"
                    )}
                    totalImages={1}
                    closePopup={() => togglePopup("addressProof")}
                    handleImageValue={handleImageValue}
                    uploadedImage={formik?.values?.addressProofImage}
                    fieldName={"addressProofImage"}
                    handleUpdateImageData={handleUpdateImageData}
                    handlePhysicalImage={handlePhysicalImage}
                    selectedOptionValue={formik?.values?.isPhysicalAddressProof}
                    dynamicSize={2}
                  />
                )}
              </Grid>
            )}

            {/* Primary Document */}
            {showPrimaryDocument && (
              <Grid item xs={12}>
                <Box display="flex" alignItems="center" gap={1}>
                  <Typography
                    sx={{
                      fontSize: "14px",
                      fontWeight: 600,
                      color: "#1A407D",
                    }}
                  >
                    {t(
                      "authorizedSignatoryDetails.fields.primaryDocument.label"
                    )}
                  </Typography>
                  <Tooltip
                    title={t(
                      "authorizedSignatoryDetails.fields.primaryDocument.tooltip"
                    )}
                    placement="right"
                  >
                    <IconButton size="small" sx={{ p: 0, color: "#1A407D" }}>
                      <InfoIcon />
                    </IconButton>
                  </Tooltip>
                </Box>
                <RadioGroup
                  row
                  name="primaryDocument"
                  value={formik.values.primaryDocument}
                  onChange={(e) =>
                    formik.setFieldValue("primaryDocument", e.target.value)
                  }
                >
                  <FormControlLabel
                    value="Aadhaar"
                    control={<Radio />}
                    label={t(
                      "authorizedSignatoryDetails.fields.primaryDocument.options.aadhaar"
                    )}
                    sx={{
                      "& .MuiFormControlLabel-label": {
                        fontSize: "14px",
                      },
                    }}
                  />
                  <FormControlLabel
                    value="PAN"
                    control={<Radio />}
                    label={t(
                      "authorizedSignatoryDetails.fields.primaryDocument.options.pan"
                    )}
                    sx={{
                      "& .MuiFormControlLabel-label": {
                        fontSize: "14px",
                      },
                    }}
                  />
                </RadioGroup>
              </Grid>
            )}

            {/* Salutation / First Name */}
            <Grid item xs={12} sm={6}>
              <Grid container spacing={1}>
                <Grid item xs={12} sm={5} md={4} lg={4} xl={4}>
                  <div className="salutationWidth">
                    <SelectInput
                      field={{
                        label: "Salutation",
                        name: "salutation",
                        readonly: false,
                        required: true,
                        options: masterData?.Salutation,
                        placeholder: t(
                          "authorizedSignatoryDetails.fields.salutation.placeholder"
                        ),
                        handleOnChange: handleSalutationChange,
                      }}
                      formik={formik}
                    />
                  </div>
                </Grid>
                <Grid item xs={12} sm={7} md={8} lg={8} xl={8}>
                  <TextFieldInput
                    field={{
                      name: "firstName",
                      label: t(
                        "authorizedSignatoryDetails.fields.firstName.label"
                      ),
                      placeholder: t(
                        "authorizedSignatoryDetails.fields.firstName.placeholder"
                      ),
                      required: true,
                      handleOnChange: (e) => {
                        const newValue = e.target.value?.replace(
                          /[^a-zA-Z\s]/g,
                          ""
                        );
                        formik.setFieldValue("firstName", newValue);
                      },
                      readonly: isNameFieldsDisabled ? false : true,
                    }}
                    formik={formik}
                  />
                </Grid>
              </Grid>
            </Grid>

            {/* Last Name */}
            <Grid item xs={12} sm={6}>
              <TextFieldInput
                field={{
                  name: "lastName",
                  label: t("authorizedSignatoryDetails.fields.lastName.label"),
                  required: false,
                  placeholder: t(
                    "authorizedSignatoryDetails.fields.lastName.placeholder"
                  ),
                  handleOnChange: (e) => {
                    const newValue = e.target.value?.replace(
                      /[^a-zA-Z\s]/g,
                      ""
                    );
                    formik.setFieldValue("lastName", newValue);
                  },
                  readonly: isNameFieldsDisabled ? false : true,
                }}
                formik={formik}
              />
            </Grid>

            {/* Care of */}
            {!hasContinuedAsMinor && (
              <Grid item xs={12} sm={6}>
                <Grid container spacing={1}>
                  <Grid item xs={12} sm={5} md={4} lg={4} xl={4}>
                    <div className="salutationWidth">
                      <SelectInput
                        field={{
                          name: "relation",
                          label: t("commonLabels.careOf"),
                          required: true,
                          readonly: false,
                          options: masterData?.Identity,
                          placeholder: t("commonPlaceholders.select"),
                        }}
                        formik={formik}
                      />
                    </div>
                  </Grid>
                  <Grid item xs={12} sm={7} md={8} lg={8} xl={8}>
                    <div>
                      <TextFieldInput
                        field={{
                          name: "relativeName",
                          placeholder: t("commonPlaceholders.name"),
                          label: t("commonLabels.name"),
                          required: true,
                          readonly: false,
                          handleOnChange: (e) => {
                            const newValue = e.target.value?.replace(
                              /[^a-zA-Z\s]/g,
                              ""
                            );
                            formik.setFieldValue("relativeName", newValue);
                          },
                        }}
                        formik={formik}
                      />
                    </div>
                  </Grid>
                </Grid>
              </Grid>
            )}

            {/* Gender */}
            <Grid item xs={12} sm={6}>
              <BoxCheckInput
                field={{
                  name: "gender",
                  label: t("commonLabels.gender"),
                  required: true,
                  readonly: false,
                  options: masterData?.GenderIdentity,
                  grid: true,
                  xsCol: 4,
                  smCol: 4,
                  mdCol: 4,
                  lgCol: 4,
                  mb: 0,
                  handleOnChange,
                }}
                formik={formik}
              />
            </Grid>

            {/* DOB*/}
            <Grid item xs={12} sm={6}>
              <CustomDatePicker
                label={t("commonLabels.dob")}
                value={formik?.values?.dob}
                onChange={(date) => {
                  if (date?.target?.value) {
                    const actualAge = getTotalYears(date?.target?.value);
                    if (actualAge < MinorAge && applicantNo === 1) {
                      setDobWarningModal(true);
                    }
                    // Update Formik value
                    formik.setFieldValue("dob", date.target.value);
                  }
                }}
                name="dob"
                maxDate={new Date()}
                minDate={new Date(DATE_START_YEAR, 0, 1)}
                error={formik.touched.dob && Boolean(formik.errors.dob)}
                helperText={formik.touched.dob && formik.errors.dob}
                required={true}
                disabled={hasContinuedAsMinor ? true : false}
              />
            </Grid>

            {hasContinuedAsMinor && (
              <>
                {/* Care of Father */}
                <Grid item xs={12} sm={6}>
                  <Grid container spacing={1}>
                    <Grid item xs={12} sm={5} md={4} lg={4} xl={4}>
                      <div className="salutationWidth">
                        <TextFieldInput
                          field={{
                            name: "relationFather",
                            label: t("commonLabels.careOf"),
                            required: true,
                            readonly: true,
                            value: "Father",
                          }}
                          formik={formik}
                        />
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={7} md={8} lg={8} xl={8}>
                      <div>
                        <TextFieldInput
                          field={{
                            name: "fatherName",
                            placeholder: t("commonPlaceholders.name"),
                            label: t("minorDetails.labels.fatherName"),
                            required: true,
                            readonly: false,
                            handleOnChange: (e) => {
                              const newValue = e.target.value?.replace(
                                /[^a-zA-Z\s]/g,
                                ""
                              );
                              formik.setFieldValue("fatherName", newValue);
                            },
                          }}
                          formik={formik}
                        />
                      </div>
                    </Grid>
                  </Grid>
                </Grid>

                {/* Care of Mother */}
                <Grid item xs={12} sm={6}>
                  <Grid container spacing={1}>
                    <Grid item xs={12} sm={5} md={4} lg={4} xl={4}>
                      <div className="salutationWidth">
                        <TextFieldInput
                          field={{
                            name: "relationMother",
                            label: t("commonLabels.careOf"),
                            required: true,
                            readonly: true,
                            value: "Mother",
                          }}
                          formik={formik}
                        />
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={7} md={8} lg={8} xl={8}>
                      <div>
                        <TextFieldInput
                          field={{
                            name: "motherName",
                            placeholder: t("commonPlaceholders.name"),
                            label: t("minorDetails.labels.motherName"),
                            required: true,
                            readonly: false,
                            handleOnChange: (e) => {
                              const newValue = e.target.value?.replace(
                                /[^a-zA-Z\s]/g,
                                ""
                              );
                              formik.setFieldValue("motherName", newValue);
                            },
                          }}
                          formik={formik}
                        />
                      </div>
                    </Grid>
                  </Grid>
                </Grid>

                {/* Legal Guardian */}
                <Grid item xs={12} sm={6}>
                  <BoxCheckInput
                    field={{
                      name: "legalGuardian",
                      label: t("minorDetails.labels.legalGuardian"),
                      required: true,
                      readonly: false,
                      options: masterData?.Relation_with_Applicant?.filter(
                        (item) =>
                          item.value === "Father" || item.value === "Mother"
                      ),
                      grid: true,
                      xsCol: 6,
                      smCol: 6,
                      mdCol: 6,
                      lgCol: 6,
                      mb: 0,
                      handleOnChange,
                    }}
                    formik={formik}
                  />
                </Grid>

                {/* Declaration */}
                <Grid item xs={12} sm={6}>
                  <UploadInput
                    field={{
                      name: "legalGuardianDoc",
                      label: t("minorDetails.labels.declaration"),
                      placeholder: formik?.values?.isPhysicalLegalGuardianDoc
                        ? t("commonPlaceholders.physicalCopy")
                        : t("minorDetails.placeholders.declaration"),
                      placeholderUpload: t(
                        "minorDetails.placeholders.declarationUploaded"
                      ),
                      required: true,
                      handleOnClick: () => togglePopup("legalGuardianDoc"),
                      physicalCopyValue:
                        formik.values?.isPhysicalLegalGuardianDoc,
                    }}
                    formik={formik}
                  />
                  {showUploadPopup?.showUploadDeclaration && (
                    <UploadPopup
                      heading={t("minorDetails.placeholders.declaration")}
                      totalImages={1}
                      closePopup={() => togglePopup("legalGuardianDoc")}
                      handleImageValue={handleImageValue}
                      uploadedImage={formik?.values?.legalGuardianDoc}
                      fieldName={"legalGuardianDoc"}
                      handleUpdateImageData={handleUpdateImageData}
                      handlePhysicalImage={handlePhysicalImage}
                      selectedOptionValue={
                        formik?.values?.isPhysicalLegalGuardianDoc
                      }
                      dynamicSize={2}
                    />
                  )}
                </Grid>
              </>
            )}

            {/* Profile Photo */}
            <Grid item xs={12} sm={6}>
              <UploadInput
                field={{
                  name: "image",
                  label: t("commonLabels.passportSizePhoto"),
                  placeholder: formik?.values?.isPhysicalImage
                    ? t(
                        "authorizedSignatoryDetails.fields.image.upload.physicalCopy"
                      )
                    : t(
                        "authorizedSignatoryDetails.fields.image.upload.placeholder"
                      ),
                  placeholderUpload: t(
                    "authorizedSignatoryDetails.fields.image.upload.placeholderUpload"
                  ),
                  required: true,
                  handleOnClick: () => togglePopup("profile"),
                  physicalCopyValue: formik?.values?.isPhysicalImage,
                }}
                formik={formik}
              />
              {showUploadPopup?.showUploadProfileImage && (
                <UploadPopup
                  heading={t(
                    "authorizedSignatoryDetails.fields.image.popup.heading"
                  )}
                  totalImages={1}
                  closePopup={() => togglePopup("profile")}
                  handleImageValue={handleImageValue}
                  uploadedImage={formik?.values?.image}
                  fieldName={"image"}
                  handleUpdateImageData={handleUpdateImageData}
                  handlePhysicalImage={handlePhysicalImage}
                  selectedOptionValue={formik?.values?.isPhysicalImage}
                  dynamicSize={2}
                />
              )}
            </Grid>

            {/* NRI Country */}
            {(formik.values.residentStatus === t("residentStatusOptions.NRI") ||
              formik.values.residentStatus ===
                t("residentStatusOptions.PIO_OCI")) && (
              <Grid item xs={12} sm={5} md={5} lg={6} xl={6}>
                <SelectInput
                  field={{
                    name: "nriCountry",
                    label: t("commonLabels.nriCountry"),
                    required: true,
                    readonly: false,
                    options: countryOptions,
                    placeholder: t("commonPlaceholders.nriCountry"),
                  }}
                  formik={formik}
                />
              </Grid>
            )}
          </Grid>
        </form>
      )}
      <CommonButton
        handlePrevious={handlePrevious}
        handleNext={handleNext}
        applicantNo={applicantNo}
        saveAndPreview={handleSaveAndPreview}
        showPrevBtn={activeStep === 0 ? true : false}
        saveDraftPath={route.UPDATE_APPLICANT_DATA}
        saveDraftData={buildPayload(true)}
      />

      <SnackbarAlert
        open={snackbarConfig.open}
        message={snackbarConfig.message}
        severity={snackbarConfig.severity}
        onClose={handleSnackbarClose}
      />
    </>
  );
});

export default PersonalDetailsIndividual;
